module.exports = __webpack_public_path__ + "img/Coin.402b0f09.png";